import styled from 'styled-components'

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: fit-content;
  flex: 1;
  height: 100%;`